// extracted by mini-css-extract-plugin
export var label = "_da-2";
export var slideContainer = "_da-0";
export var slider = "_da-1";